import { RouterProvider } from 'react-router-dom'
import { ThemeProvider } from '@mui/material/styles'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ja } from 'date-fns/locale/ja'
import { I18nextProvider } from 'react-i18next'
import { i18n } from '~/adapter/i18n'
import { router } from '~/app/routes/router'
import { useAppQueryClient } from '~/lib/tanstackQuery/queryClient'
import { theme } from '~/styles/theme'

export function Providers() {
  const { queryClient } = useAppQueryClient()

  return (
    <QueryClientProvider client={queryClient}>
      {!!import.meta.env['VITE_APP_TAN_STACK_DEVTOOLS'] && (
        <ReactQueryDevtools />
      )}
      <I18nextProvider i18n={i18n}>
        <ThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
            <RouterProvider router={router} />
          </LocalizationProvider>
        </ThemeProvider>
      </I18nextProvider>
    </QueryClientProvider>
  )
}
